import $ from 'jquery'

$('#moa-video video').on('play', () => {
  const event = new CustomEvent('whyverkaziamoavideoplayed')
  document.dispatchEvent(event)
})


// WEBPACK FOOTER //
// ./js/classes/events.js